import CouponsPremiumDetails from './CouponsDetails'

export default CouponsPremiumDetails